export default __webpack_public_path__ + "static/media/driller.b8506114.png";